const $ = jQuery.noConflict();

class View {
    static animationTimeout = 10000;

    static onResize(e) {
        const content = document.getElementsByClassName('page-content')[0];
        if (window.innerWidth > 1280) {
            if (content) {
                content.style.left = (window.innerWidth - content.clientWidth) / 2 + 'px';
            }
            //page_scene.style.position = 'fixed';
        } else {
            //page_scene.style.position = 'absolute';
            //page_scene.style.left = '-316.5px';
        }
    }

    static onLoad() {
    }

    static onIndexLoad() {
        this.onLoad();
    }

    static animateIcon(dataName) {
        const animation1 = bodymovin.loadAnimation({
            container: document.getElementById('animation-' + dataName),
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: 'assets/data/' + dataName + '-data.json'
        });

        setInterval(() => {
            animation1.stop();
            animation1.play();
        }, this.animationTimeout);
    }

    static onRevenueLoad() {
        this.onLoad();
        this.animateIcon('cards');
    }

    static onPricingLoad() {
        this.onLoad();
        this.animateIcon('calendar');
    }

    static onCleaningLoad() {
        this.onLoad();
        this.animateIcon('laundry');
    }

    static onListingsLoad() {
        this.onLoad();
        this.animateIcon('photo');
    }

    static onGuestExperienceLoad() {
        this.onLoad();
        this.animateIcon('review');
    }
}

class Utils {

    static isEmailValid = false;
    static isNameValid = false;
    static isPhoneValid = false;
    static isListingsValid = false;
    static firstValidation = true;

    static getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    static setCookie(name, value, options) {
        options = options || {};

        let expires = options.expires;

        if (typeof expires === "number" && expires) {
            const d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encodeURIComponent(value);

        let updatedCookie = name + "=" + value;

        for (const propName in options) {
            updatedCookie += "; " + propName;
            const propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }

        document.cookie = updatedCookie;
    }

    static validateEmail(email) {
        if (CommonHelper.validateEmail(email.value)) {
            this.isEmailValid = true;
            if (!this.firstValidation) {
                email.classList.remove('invalid');
            }
        } else {
            this.isEmailValid = false;
            if (!(this.firstValidation && email.value === '')) {
                email.classList.add('invalid');
            }
        }
    };

    static validateName(name) {
        if (/^[A-Za-z]+[A-Za-z\s]+$/.test(name.value)) {
            this.isNameValid = true;
            if (!this.firstValidation) {
                name.classList.remove('invalid');
            }
        } else {
            this.isNameValid = false;
            if (!(this.firstValidation && name.value === '')) {
                name.classList.add('invalid');
            }
        }
    };

    static validatePhone(phone) {
        if (/(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/.test(phone.value)) {
            this.isPhoneValid = true;
            if (!this.firstValidation) {
                phone.classList.remove('invalid');
            }
        } else {
            this.isPhoneValid = false;
            if (!(this.firstValidation && phone.value === '')) {
                phone.classList.add('invalid');
            }
        }
    };

    static validateListings(listing) {
        let listingsValue = listings.value;
        if ((/^[0-9]*$/.test(listingsValue)) && listingsValue > 0 && listingsValue < 5999 ) {
            this.isListingsValid = true;
            if (!this.firstValidation) {
                listings.classList.remove('invalid');
            }
        } else {
            this.isListingsValid = false;
            if (!(this.firstValidation && listingsValue === '')) {
                listings.classList.add('invalid');
            }
        }
    };

    static validateInputs() {
        let email = document.getElementById('email');
        let name = document.getElementById('name');
        let phone = document.getElementById('phone');
        let listings = document.getElementById('listings');

        this.validateEmail(email);
        this.validatePhone(phone);
        this.validateName(name);
        this.validateListings(listings);

        this.firstValidation = false;
    }


    static isFormDataValid() {
        return this.isEmailValid && this.isNameValid && this.isPhoneValid && this.isListingsValid;
    }

    static validateForm() {
        const submit_button = document.getElementById('submit-button');

        if (this.isFormDataValid()) {
            submit_button.disabled = false;
            submit_button.classList.remove('disabled');
        } else {
            submit_button.disabled = true;
            submit_button.classList.add('disabled');
        }
    }
}

(() => {
    if (CommonHelper.findGetParameter('apfuem5dvjd4fpxaw', null) === 'qsimv6frt') {
        Utils.setCookie('handbook-form', 1, {expires: 60 * 60 * 24 * 813});
    }
    window.addEventListener('resize', View.onResize);
    window.addEventListener('orientationchange', View.onResize);
    View.onResize(null);

    // if (Utils.getCookie('index-viewed') !== undefined) {
    //     document.body.classList.remove('start-animation');
    // }

    const cookie = Utils.getCookie('handbook-form');
    if (cookie === undefined) {
        setTimeout(() => {
            document.getElementById('form-wrapper').style.visibility = 'visible';
            document.getElementById('form-overlay').style.visibility = 'visible';
            document.getElementById('form-wrapper').style.opacity = 1;
            document.getElementById('form-overlay').style.opacity = .8;
        }, 2000);
    }

    Utils.validateInputs();
    Utils.validateForm();

    const $close_link = $('#close-link');
    $close_link.on('mousedown touchstart', event => {
        if (event.currentTarget.href) {
            window.location.replace(event.currentTarget.href);
        }
        event.stopPropagation();
        return false;
    });

    const form = document.getElementById('handbook-form');
    let form_submitted = false;
    if (form) {
        const tSource = document.getElementById('source');
        if (tSource) {
            tSource.value = CommonHelper.findGetParameter('source', 'unknown');
        }
        form.addEventListener('submit', event => {
            event.preventDefault();
            if (!Utils.isFormDataValid()) {
                return;
            }
            if (window.ga) {
                ga('send', 'event', {
                    eventCategory: 'STRGuide',
                    eventAction: 'formSubmit',
                    hitCallback: () => {
                        form.submit();
                        form_submitted = true;
                    },
                });
            } else {
                form.submit();
                form_submitted = true;
            }
            setTimeout(() => {
                if (form_submitted === false) {
                    form.submit();
                    form_submitted = true;
                }
            }, 2000);
        });
    }
})();
